/**
 * Data Files API
 * მონაცემთა ფაილების API
 */

import { get, post, del, upload } from '@aiia/portal-core';

export interface DataFile {
  id: string;
  userId: string;
  fileName: string;
  fileType: string;
  fileSize: number;
  storagePath?: string;
  vectorStoreId?: string;
  status: 'PENDING' | 'PROCESSING' | 'READY' | 'FAILED' | 'DELETED';
  chunkCount?: number;
  embeddingModel?: string;
  vectorizedAt?: string;
  errorMessage?: string;
}

// Get all data files for current user
export const getDataFiles = () =>
  get<DataFile[]>('/data-files');

// Get data file by ID
export const getDataFile = (fileId: string) =>
  get<DataFile>(`/data-files/${fileId}`);

// Upload data file
export const uploadDataFile = (
  file: File,
  onProgress?: (progress: number) => void
) =>
  upload<DataFile>(
    '/data-files/upload',
    file,
    'file',
    undefined,
    onProgress
  );

// Delete data file
export const deleteDataFile = (fileId: string) =>
  del<void>(`/data-files/${fileId}`);

// Reprocess data file
export const reprocessDataFile = (fileId: string) =>
  post<DataFile>(`/data-files/${fileId}/process`, {});
